module.exports = __webpack_public_path__ + "static/media/jcb.f9905aea.svg";